import { Droplets } from "lucide-react";
import { Card } from "@/components/clinician/ClientDetailParts";

/** Social-connection signal: garden waters given / received over the last 4 weeks. Never shows other members' identities. */
export function KindnessCard({ kindness }) {
  if (!kindness) return null;
  const max = Math.max(1, ...kindness.weeks.flatMap((w) => [w.gave, w.received]));
  const quiet = kindness.gave_30 + kindness.received_30 === 0;
  return (
    <Card icon={Droplets} iconCls="text-sky-700" title="Community connection · last 30 days" testid="kindness-card">
      <div className="flex flex-wrap gap-4 text-sm">
        <div><span className="font-mono text-xl font-bold text-stone-900" data-testid="kindness-gave">{kindness.gave_30}</span> <span className="text-stone-500">waters given</span></div>
        <div><span className="font-mono text-xl font-bold text-stone-900" data-testid="kindness-received">{kindness.received_30}</span> <span className="text-stone-500">received</span></div>
        <div><span className="font-mono text-xl font-bold text-stone-900" data-testid="kindness-thanks">{kindness.thanks_30}</span> <span className="text-stone-500">thank-yous sent</span></div>
        {kindness.streak > 0 && <div className="text-xs text-sky-800 self-center" data-testid="kindness-streak">Watering streak: {kindness.streak} day{kindness.streak === 1 ? "" : "s"}</div>}
      </div>
      <div className="mt-4 grid grid-cols-4 gap-3" data-testid="kindness-weeks">
        {kindness.weeks.map((w) => (
          <div key={w.week_start} className="text-center">
            <div className="flex items-end justify-center gap-1 h-16">
              <div className="w-4 rounded-t bg-sky-600" style={{ height: `${Math.max(4, (w.gave / max) * 100)}%` }} title={`Gave ${w.gave}`} />
              <div className="w-4 rounded-t bg-emerald-400" style={{ height: `${Math.max(4, (w.received / max) * 100)}%` }} title={`Received ${w.received}`} />
            </div>
            <div className="text-[10px] text-stone-500 mt-1 font-mono">{w.week_start.slice(5)}</div>
            <div className="text-[10px] text-stone-600"><span className="text-sky-700 font-bold">{w.gave}</span> · <span className="text-emerald-700 font-bold">{w.received}</span></div>
          </div>
        ))}
      </div>
      <p className="text-xs text-stone-500 mt-3">
        {quiet ? "No community watering yet — a quiet signal, not a problem. Reaching out to others often follows feeling steadier." : "Giving and receiving small kindnesses is a gentle social-connection signal. Other members appear only as anonymous handles to the member; none are shown here."}
      </p>
    </Card>
  );
}
